import React, { useEffect, useState } from "react";
import DataCollectionView from "../DataCollectionView/DataCollectionView";
import DataCollectionViewV2 from "../DataCollectionViewV2/DataCollectionViewV2";
import { getSettingPreferences } from "../../../services/orgService";

export default function DataCollection() {
  let [template, setTemplate] = useState("");
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    getSettingPreferences(
      false,
      parseInt(searchParams.get("customer") || "-1")
    ).then((data) => {
      if (data.status == 200) {
        template = data.data.supplier_template;
        setTemplate(template);
      }
    });
  }, []);
  return template ? (
    template == "Standard" ? (
      <DataCollectionViewV2></DataCollectionViewV2>
    ) : (
      <DataCollectionView></DataCollectionView>
    )
  ) : (
    <></>
  );
}
